import React, { Fragment, useContext, useState, useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import CustomizerContext from '../../../../_helper/Customizer';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { ImpactApi } from '../../../../api';
import { toast } from 'react-toastify';
import CardRibbonWithForm from '../../../Common/Component/CardRibbonWithForm';
import { base_form_fields, color_field, dynamic_field } from '../../../../Data/FormField/PublicData';
import useAxiosPrivate from '../../../../Hooks/useAxiosPrivate';
import { Impact, ImpactColor, Weight } from '../../../../Constant';
import useAuth from '../../../../Hooks/useAuth';
//import Dropzone from 'react-dropzone-uploader';

const ImpactCreate = () => {
  const [formFields, setFormFields] = useState(base_form_fields(`${Impact}`))
  const [IsNewFieldAdded, setIsNewFieldAdded] = useState(false)
  const history = useNavigate();
  const axiosPrivate = useAxiosPrivate()
  const { userOrganisationId } = useAuth();
  const { layoutURL } = useContext(CustomizerContext);
  const lists = `${process.env.PUBLIC_URL}/crm/settings/impacts/${layoutURL}`;

  const { formState: { errors }, } = useForm();
  const addNewRecord = async (newRecord) => {
    if (newRecord === '') {
      errors.showMessages();
    }

    const newRecordTemp = {
      organisation_id: userOrganisationId,
      name: newRecord.name,
      description: newRecord.description,
      color: newRecord.color,
      weight: newRecord.weight,
      is_active: newRecord.is_active,
    };

    try {
      await axiosPrivate.post(ImpactApi, newRecordTemp, {
        headers: {
          //'Content-Type': 'multipart/form-data',
          'Content-Type': 'application/json',
        },
      }).then((resp) => {
        toast.success(`${resp.data.name} is successfully added.`)
        history(lists);
      });
    } catch (error) {
      if (error.response && error.response.status === 422) {
        toast.error('Validation Errors');
      } else if (error.response && error.response.status === 400) {
        toast.error(error.response.data.detail);
      }
      else {
        toast.error('Form submission error');
      }
      throw error;
    }
  };

  /*   const getUploadParams = ({ meta }) => {
      return {
        url: 'http://localhost:8001/public-data/upload',
      };
    };
  
    // called every time a file's `status` changes
    const handleChangeStatus = ({ meta, file }, status) => {}; */
  useEffect(() => {

    const fetchData = async () => {
      try {
        if (!IsNewFieldAdded) {

          const updatedFields = [...formFields];
          const indexOfName = updatedFields.findIndex((formField) => formField.id === 'description');
          updatedFields.splice(indexOfName + 1, 0, color_field(`${ImpactColor}`));
          updatedFields.splice(indexOfName + 2, 0, dynamic_field('weight', `${Weight}`, 'number'));
        
          setFormFields(updatedFields);
          setIsNewFieldAdded(true);
        }
      } catch (error) {
        //console.error('Error fetching options:', error);
      }
    };

    fetchData();
  }, [formFields, IsNewFieldAdded, color_field]);

  return (
    <Fragment>
      <Breadcrumbs parent="CRM" title="New Impact" mainTitle="New Impact" />
      <Container fluid={true}>
        <Row>
          <Col sm='10'>
            <CardRibbonWithForm formFields={formFields} onSubmit={addNewRecord} ribbonUrl={lists} />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default ImpactCreate;